import { render } from "./OrderDetails.vue?vue&type=template&id=3a5f08f3"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__